import React, { useState, useEffect, useRef } from 'react';
import io from 'socket.io-client';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';

import { useParams } from 'react-router-dom';
import Alert from './Alert';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import api from '../services/api';
import LanguageSelector from './LanguageSelector';

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import Select from 'react-select';
import countryList from 'country-list';

import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//import { fr, enGB, es, de, it } from "date-fns/locale";

import {
  fr,
  enGB,
  enUS,
  es,
  de,
  it,
  arSA,
  pt,
  da,
  nb,
  fi,
  sv,
  uk,
  hu,
  is,
  el,
  ro,
  bg,
  sr,
  sl,
  et,
  lv,
  lt,
  hr,
  cs,
  sk,
  nl,
  pl,
mt,
} from "date-fns/locale";

const Profile = ({ socket, email, prompt }) => {
  const [profile, setProfile] = useState({});
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
const [showEmail, setShowEmail] = useState('');
const [showPhone, setShowPhone] = useState('');
const [ville, setVille] = useState('');
const [pays, setPays] = useState('');
const [bio, setBio] = useState('');
const [birthDate, setBirthDate] = useState('');
const [facebook, setFacebook] = useState('');
const [instagram, setInstagram] = useState('');
const [linkedin, setLinkedin] = useState('');
const [website, setWebsite] = useState('');
const [timezone, setTimezone] = useState('');

  const [phoneNumber, setPhoneNumber] = useState('');
  const [profileImage, setProfileImage] = useState(null);
const [successMessage, setSuccessMessage] = useState('');
const [errorMessage, setErrorMessage] = useState('');
const { id } = useParams();
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const token = localStorage.getItem('token');
const { t } = useTranslation();
const location = useLocation();
const navigate = useNavigate();
const fileInputRef = useRef(null);

const [selectedLang, setSelectedLang] = useState(profile.lang || i18n.language);

useEffect(() => {
  if (profile.lang) setSelectedLang(profile.lang);
}, [profile.lang]);

const fromDiscussionId = location.state?.fromDiscussion;
  useEffect(() => {
    // Récupérer les infos du profil au chargement
    const fetchProfile = async () => {
      

      const response = await api.get(`${API_URL}/api/profil/profile`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setProfile(response.data);
 setFirstName(response.data.firstName || '');
      setLastName(response.data.lastName || '');
setShowEmail(!!response.data.settings?.showEmail);
setShowPhone(!!response.data.settings?.showPhone);
      setVille(response.data.ville || '');
      setPays(response.data.pays || '');
      setPhoneNumber(response.data.phoneNumber || '');
      setProfileImage(response.data.profileImage || null);
setBio(response.data.bio || '');
setBirthDate(response.data.birthDate || '');
setFacebook(response.data.facebook || '');
setInstagram(response.data.instagram || '');
setLinkedin(response.data.linkedin || '');
setWebsite(response.data.website || '');
setTimezone(response.data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone);
    };
    fetchProfile();
  }, [id, socket]);

const localeMap = {
  fr: fr,
    en: enGB,
    es: es,
    de: de,
    it: it,
    ar: arSA,
    pt: pt,
    da: da, // ← 'da' est le danois → Danemark = 'dk'
    no: nb,
    fi: fi,
  sv: sv,
  uk: uk,
  hu: hu,
  is: is,
  el: el,
  ro: ro,
  bg: bg,
  sr: sr,
  sl: sl,
  et: et,
  lv: lv,
  lt: lt,
  hr: hr,
  cs: cs,
  sk: sk,
  nl: nl,
  pl: pl,
mt:mt,

};

const currentLocale = localeMap[i18n.language] || enGB;

const getLocaleDateFormat = (locale) => {
  const parts = new Intl.DateTimeFormat(locale).formatToParts(new Date(2000, 11, 31));

  return parts
    .map(part => {
      if (part.type === 'day') return 'dd';
      if (part.type === 'month') return 'MM';
      if (part.type === 'year') return 'yyyy';
      return part.value;
    })
    .join('');
};

const currentDateFormat = getLocaleDateFormat(i18n.language);

const getDefaultCountry = () => {
  const lang = i18n.language;
  const map = {
    'fr': 'fr',
    'en': 'gb',
    'es': 'es',
    'de': 'de',
    'it': 'it',
    'ar': 'ma',
    'pt': 'pt',
    'da': 'dk', // ← 'da' est le danois → Danemark = 'dk'
    'no': 'no',
    'fi': 'fi',
    'sv': 'se', // ← 'sv' est le suédois → Suède = 'se'
    'uk': 'ua', // ✅
    'hu': 'hu',
    'is': 'is',
    'el': 'gr', // ← 'el' est le grec → Grèce = 'gr'
    'ro': 'ro',
    'bg': 'bg',
    'sr': 'rs', // ← 'sr' est le serbe → Serbie = 'rs'
    'sl': 'si', // ← 'sl' est le slovène → Slovénie = 'si'
    'et': 'ee', // ← 'et' est l'estonien → Estonie = 'ee'
    'lv': 'lv',
    'lt': 'lt',
    'hr': 'hr',
    'cs': 'cz', // ← 'cs' est le tchèque → Tchéquie = 'cz'
    'sk': 'sk',
    'nl': 'nl',
    'pl': 'pl',
    'mt': 'mt',
  };
  return map[lang] || 'fr';
};

// Générer la liste des fuseaux via API native — pas de librairie
const getTimezoneOptions = () => {
  return Intl.supportedValuesOf('timeZone').map(tz => ({
    value: tz,
    label: `${tz} (UTC${getUTCOffset(tz)})`,
  }));
};

const getUTCOffset = (tz) => {
  const offset = new Intl.DateTimeFormat('en', {
    timeZone: tz,
    timeZoneName: 'shortOffset',
  }).formatToParts(new Date()).find(p => p.type === 'timeZoneName')?.value || '';
  return offset.replace('GMT', '');
};

const isValidPhoneNumber = (number) => {
  if (!number || number.trim() === '') return true;
  
  // ✅ Retire tous les chiffres non numériques
  const digits = number.replace(/\D/g, '');
  
  // ✅ Si l'utilisateur a tout effacé, il reste juste l'indicatif (1 à 3 chiffres)
  // On considère ça comme "vide" → valide
  if (digits.length <= 3) return true;
  
  // Sinon, numéro complet : entre 8 et 15 chiffres
  return digits.length >= 8 && digits.length <= 15;
};
  const handleUpdateProfile = async (event) => {
   event.preventDefault(); // Éviter le comportement par défaut du formulaire
 const cleanedFirstName = typeof firstName === 'string' ? firstName.trim() : '';
  const cleanedLastName = typeof lastName === 'string' ? lastName.trim() : '';

const cleanedVille = typeof ville === 'string' ? ville.trim() : '';
  const cleanedPays = typeof pays === 'string' ? pays.trim() : '';

  const cleanedPhoneNumber = typeof phoneNumber === 'string' ? phoneNumber.trim() : '';
// ✅ Traite l'indicatif seul (≤ 3 chiffres) comme un champ vide
  const phoneDigits = cleanedPhoneNumber.replace(/\D/g, '');
  const phoneToSave = phoneDigits.length <= 3 ? '' : cleanedPhoneNumber;
const { alert } = prompt;
  if (phoneToSave && !isValidPhoneNumber(phoneToSave)) {
    await alert(t('profile.alertphone'));
    return;
  }
  const formData = new FormData();
  formData.append('firstName', cleanedFirstName);
  formData.append('lastName', cleanedLastName);
formData.append('ville', cleanedVille);
  formData.append('pays', cleanedPays);
  formData.append('phoneNumber', phoneToSave); 
  formData.append('lang', i18n.language);
formData.append('bio', bio.trim());
formData.append('birthDate', birthDate);
formData.append('facebook', facebook.trim());
formData.append('instagram', instagram.trim());
formData.append('linkedin', linkedin.trim());
formData.append('website', website.trim());
formData.append('timezone', timezone);
//formData.append('showEmail', showEmail);
//formData.append('showPhone', showPhone);

  if (profileImage) {
    formData.append('profileImage', profileImage);
  }

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    try {
      const token = localStorage.getItem('token');
      const response = await api.put(`${API_URL}/api/profil/profile`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
   
  });

      // Mettre à jour les états avec les nouvelles données du profil
      
	setProfile(response.data);
    setFirstName(response.data.firstName || '');
    setLastName(response.data.lastName || '');
    setVille(response.data.ville || '');
    setPays(response.data.pays || '');
    setPhoneNumber(response.data.phoneNumber || '');
    setProfileImage(response.data.profileImage || null);
setBio(response.data.bio || '');
setBirthDate(response.data.birthDate || '');
setFacebook(response.data.facebook || '');
setInstagram(response.data.instagram || '');
setLinkedin(response.data.linkedin || '');
setWebsite(response.data.website || '');
setTimezone(response.data.timezone || '');

    setSuccessMessage(t('profile.succes'));
  } catch (error) {
    console.error('Erreur lors de la mise à jour du profil:', error);
// ✅ Message détaillé du serveur si disponible
  const msg = error.response?.data?.message || t('profile.error');
  setErrorMessage(msg);
    //setErrorMessage(t('profile.error'));
  }
  };




let imageName = null;

if (profile.profileImageNew) {
  // Si tu veux juste le nom du fichier local
  if (profile.profileImageNew.localPath) {
    imageName = profile.profileImageNew.localPath.split('/').pop();
  } 
  // Option Cloudinary
  else if (profile.profileImageNew.cloudinaryUrl) {
    imageName = profile.profileImageNew.cloudinaryUrl.split('/').pop();
  }
} else if (profile.profileImage && profile.profileImage.localPath) {
  // Ancien format
  imageName = profile.profileImage.localPath.split('/').pop();
}

if (!imageName) {
  imageName = 'default-profile.png';
}



const handleBackToDiscussions = () => {
    if (fromDiscussionId) {
      // Revenir à la discussion fullscreen
      navigate('/', {
        state: { reopenDiscussionId: fromDiscussionId },
      });
    } else {
      navigate(-1); // comportement par défaut
    }
  };

// Helper pour récupérer l'URL du profil
function getProfileImageUrl(profile, token) {
  if (!profile) return `${API_URL}/uploads/default-profile.png`;

  // Ancien format : string
  if (typeof profile.profileImage === "string" && profile.profileImage.trim() !== "") {
    return `${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${profile._id}?token=${token}&type=image&thumb=true&profile=true&t=${profile.profileImageUpdatedAt}`;
  }

  // Nouveau format : objet
  if (profile.profileImage && typeof profile.profileImage === "object") {
//if (profile.profileImage.localPath != null){
    const hasLocalOrCloud = profile.profileImage.localPath || profile.profileImage.cloudinaryUrl;
    if (hasLocalOrCloud) {
      return `${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${profile._id}?token=${token}&type=image&thumb=true&profile=true&t=${profile.profileImageUpdatedAt}`;
    }
//}
  }

  // Sinon fallback : image par défaut
  return `${API_URL}/uploads/default-profile.png`;
}

const hasProfileImage =
  profile.profileImage &&
  (
    profile.profileImage.ciphertext ||
    profile.profileImage.cloudinaryUrl ||
    profile.profileImage.localPath
  );

// Juste avant le return, dans le composant Profile :

const getCountryOptions = (lang) => {
  const regionNames = new Intl.DisplayNames([lang], { type: 'region' });
  return countryList.getCodes().map(code => ({
    value: code,
    label: regionNames.of(code),
  })).sort((a, b) => a.label.localeCompare(b.label));
};

// Dans le composant :
const countryOptions = getCountryOptions(i18n.language);

// Pour pré-sélectionner le pays actuel depuis le profil :
const selectedCountry = countryOptions.find(c => c.value === pays) || null;

// Récupère les variables CSS du thème courant
const getThemeStyles = () => {
  const styles = getComputedStyle(document.documentElement);
  return {
    inputBg: styles.getPropertyValue('--input-bg').trim(),
    inputColor: styles.getPropertyValue('--input-color').trim(),
  };
};
const { inputBg, inputColor } = getThemeStyles();
const birthDateObj = birthDate ? new Date(birthDate) : null;
const timezoneOptions = getTimezoneOptions();
const selectedTimezone = timezoneOptions.find(o => o.value === timezone) || null;

const openExternalLink = (url) => {
  if (!url) return;
  if (window.cordova) {
    // _blank ouvre dans InAppBrowser (dans l'appli) avec bouton retour intégré
    cordova.InAppBrowser.open(url, '_blank', 'location=yes,closebuttoncaption=Retour,toolbar=yes');
  } else {
    window.open(url, '_blank');
  }
};

 return (


    <div className="profile-update">

      <h1>{t('profile.infos')}</h1>

      <div className="profile-image-container">
        <img
  
src={getProfileImageUrl(profile, token)}

  alt="Profile"
  className="profile-image"
/>
{hasProfileImage && (

  <button
   style={{ background: 'none', border: 'none', padding: 5, cursor: 'pointer' }}
    onClick={async () => {
const { alert, confirm} = prompt;
      const confirmDelete = await confirm(t('profile.alertdelete'));
      if (!confirmDelete) return;

      try {
        const response = await api.delete(`${API_URL}/api/profil/profile-image`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setProfileImage(null); // On efface l’image côté interface
        setProfile({ ...profile, profileImage: null }); // Mise à jour du profil
        setSuccessMessage(t('profile.succesmessage'));
      } catch (error) {
        console.error("Erreur suppression image:", error);
        setErrorMessage(t('profile.errormessage'));
      }
    }}
  >
    🗑️
  </button>
)}

      </div>

     <div className="profile-info">
  <p style={{display: 'flex', justifyContent: 'space-between',  alignItems: 'center' }}>
<span style={{ display: 'flex', gap: '7px', alignItems: 'center' }}>
<strong>{t('profile.username')}</strong>
{profile.username}
</span>
<span
  className="info-bubble"
style={{ marginLeft:  '0', display: 'flex',  gap: '7px',  alignItems: 'center' }}
  onClick={() =>
    prompt.alert(
      <span
        dangerouslySetInnerHTML={{
          __html: t('profile.modifidentifiant')
        }}
      />
    )
  }
>
   <i className="ti ti-info-circle" style={{ fontSize: '16px', color: '#3498db' }} aria-hidden="true" />


  </span>
 </p>
<hr className="separator"/>

  <p style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  
  {/* Partie gauche */}
  <span style={{ display: 'flex', gap: '7px', alignItems: 'center' }}>
    <strong>{t('profile.email')}</strong>
    {profile.email}
  </span>

  {/* Partie droite */}
  <span style={{ display: 'flex', gap: '7px', alignItems: 'center' }}>
    {profile.settings?.showEmail ? (
      <>
        <span>👁️</span>
        <span
          className="info-bubble"
          onClick={() =>
            prompt.alert(
              <span
                dangerouslySetInnerHTML={{
                  __html: t('profile.masque_email')
                }}
              />
            )
          }
        >
           <i className="ti ti-info-circle" style={{ fontSize: '16px', color: '#3498db' }} aria-hidden="true" />

      
        </span>
      </>
    ) : (
      <span>🙈</span>
    )}
  </span>

</p>
<hr className="separator"/>


  <p><strong>{t('profile.firstname')}</strong>
    {typeof profile.firstName === 'string' && profile.firstName.trim()
      ? profile.firstName
      : t('profile.empty')}
  </p>
<hr className="separator"/>

  <p><strong>{t('profile.name')}</strong>
    {typeof profile.lastName === 'string' && profile.lastName.trim()
      ? profile.lastName
      : t('profile.empty')}
  </p>
<hr className="separator"/>

<div style={{display: 'flex', justifyContent: 'space-between',  alignItems: 'center' }}>
 <div style={{ display: 'flex', gap: '7px', alignItems: 'center' }}>
<strong>{t('profile.birthdate')}</strong>
<span >

  {profile.birthDate
    ? new Date(profile.birthDate).toLocaleDateString(i18n.language, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    : t('profile.empty')}
</span>
</div>
<span
  className="info-bubble"
style={{ marginLeft:  '0', display: 'flex',  gap: '7px',  alignItems: 'center' }}
  onClick={() =>
    prompt.alert(
      <span
        dangerouslySetInnerHTML={{
          __html: t('profile.birthdate_info')
        }}
      />
    )
  }
>
   <i className="ti ti-info-circle" style={{ fontSize: '16px', color: '#3498db' }} aria-hidden="true" />


  </span>

</div>

<hr className="separator"/>

  <p style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  
  {/* Partie gauche */}
  <span style={{ display: 'flex', gap: '7px', alignItems: 'center' }}>
    <strong>{t('profile.phonenumber')}</strong>

    {typeof profile.phoneNumber === 'string' && profile.phoneNumber.trim() ? (
      <>
        {profile.phoneNumber}
      </>
    ) : (
      <span>{t('profile.empty')}</span>
    )}
  </span>

  {/* Partie droite (icônes) */}
  {typeof profile.phoneNumber === 'string' && profile.phoneNumber.trim() && (
    <span style={{ display: 'flex', gap: '7px', alignItems: 'center' }}>
      {profile.settings?.showPhone ? (
        <>
          <span>👁️</span>
          <span
            className="info-bubble"
            onClick={() =>
              prompt.alert(
                <span
                  dangerouslySetInnerHTML={{
                    __html: t('profile.masque_phone')
                  }}
                />
              )
            }
          >
            <i className="ti ti-info-circle" style={{ fontSize: '16px', color: '#3498db' }} aria-hidden="true" />


          </span>
        </>
      ) : (
        <span>🙈</span>
      )}
    </span>
  )}

</p>
<hr className="separator"/>

<p><strong>{t('profile.ville')}</strong>
    {typeof profile.ville === 'string' && profile.ville.trim()
      ? profile.ville
      : t('profile.empty')}
  </p>
<hr className="separator"/>

<p><strong>{t('profile.pays')}</strong>
    {typeof profile.pays === 'string' && profile.pays.trim()
      ? profile.pays
      : t('profile.empty')}
  </p>
<hr className="separator"/>

<p><strong>{t('profile.timezone')}</strong>
  {timezone
    ? `${timezone} (UTC${getUTCOffset(timezone)})`
    : t('profile.empty')}
</p>
<hr className="separator"/>

<p style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
<span style={{display: 'flex', gap: '7px', alignItems: 'center'}}>
<strong>{t('profile.langue')}</strong>
{typeof profile.lang === 'string' && profile.lang.trim()
    ? t(`languages.${profile.lang}`, { defaultValue: profile.lang })
    : t('profile.empty')}
</span>
<span
  className="info-bubble"
style={{display: 'flex', marginLeft: '0', gap: '7px', alignItems: 'center'}}
  onClick={() =>
    prompt.alert(
      <span
        dangerouslySetInnerHTML={{
          __html: t('profile.language_explication')
        }}
      />
    )
  }
>
   <i className="ti ti-info-circle" style={{ fontSize: '16px', color: '#3498db' }} aria-hidden="true" />


  </span>
</p>
<hr className="separator"/>

<p><strong>{t('profile.bio')}</strong>
  {typeof profile.bio === 'string' && profile.bio.trim()
    ? profile.bio
    : t('profile.empty')}
</p>
<hr className="separator"/>

<p><strong>{t('profile.social')}</strong>
  <div style={{ display: 'flex', gap: '8px', marginTop: '6px' }}>

    {typeof profile.facebook === 'string' && profile.facebook.trim() && (
<span onClick={() => openExternalLink(profile.facebook)} style={{ cursor: 'pointer' }} title="Facebook">

      <img src={`${API_URL}/uploads/icon-facebook.png`} alt="Facebook" style={{ width: '24px' }} />
</span>
    )}

    {typeof profile.instagram === 'string' && profile.instagram.trim() && (
<span onClick={() => openExternalLink(profile.instagram)} style={{ cursor: 'pointer' }} title="Facebook">
      <img src={`${API_URL}/uploads/icon-instagram.png`} alt="Instagram" style={{ width: '24px' }} />
</span>
    )}

    {typeof profile.linkedin === 'string' && profile.linkedin.trim() && (
<span onClick={() => openExternalLink(profile.linkedin)} style={{ cursor: 'pointer' }} title="Facebook">

      <img src={`${API_URL}/uploads/icon-linkedin.png`} alt="LinkedIn" style={{ width: '24px' }} />
</span>
    )}

    {typeof profile.website === 'string' && profile.website.trim() && (
<span onClick={() => openExternalLink(profile.website)} style={{ cursor: 'pointer' }} title="Facebook">

      <img src={`${API_URL}/uploads/icon-website.png`} alt="Site web" style={{ width: '24px' }} />
</span>
    )}

    {!profile.facebook && !profile.instagram && !profile.linkedin && !profile.website && t('profile.empty')}

  </div>
</p> 
</div>


      <h3>{t('profile.update')}</h3>
     
   
      <div className="update-form">
<LanguageSelector value={selectedLang} onChange={setSelectedLang} />
        <input 
          type="text" 
          placeholder={t('profile.firstname')}
          value={firstName ?? ''} 
          onChange={(e) => setFirstName(e.target.value)} 
        />
        <input 
          type="text" 
         placeholder={t('profile.name')}
          value={lastName ?? ''} 
          onChange={(e) => setLastName(e.target.value)} 
        />


<DatePicker
  selected={birthDateObj}
  onChange={(date) => {
    if (!date) {
      setBirthDate('');
    } else {
      // format ISO pour ton backend
      const iso = date.toISOString().split('T')[0];
      setBirthDate(iso);
    }
  }}
  dateFormat={currentDateFormat}
  placeholderText={t('profile.birthdate_label')}
  locale={currentLocale}
  maxDate={new Date()}
  minDate={new Date("1900-01-01")}
  showYearDropdown
  scrollableYearDropdown
  yearDropdownItemNumber={100}
  className="textarea"
  isClearable
/>
<div style={{ position: 'relative', width: '100%' }}>
        <PhoneInput
  country={getDefaultCountry()}                        // pays par défaut
  value={phoneNumber ?? ''}
  onChange={(value) => setPhoneNumber('+' + value)}
  inputStyle={{ width: '100%' }}
  enableSearch={true}                   // recherche dans la liste des pays
  searchPlaceholder="Rechercher..."
  preferredCountries={['fr', 'be', 'ch', 'ca', 'ma', 'sn']} // pays en haut de liste
/>
{phoneNumber && (
    <button
      type="button"
      onClick={() => setPhoneNumber('')}
      style={{
        position: 'absolute',
        right: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        fontSize: '16px',
        opacity: 0.6,
color: '#000'
      }}
    >
      ✕
    </button>
  )}

</div>
        <input 
          type="text" 
         placeholder={t('profile.ville')}
          value={ville ?? ''} 
          onChange={(e) => setVille(e.target.value)} 
        />

      <Select
  options={countryOptions}
  value={selectedCountry}
  onChange={(option) => setPays(option ? option.value : '')}
  placeholder={t('profile.pays')}
  isSearchable={true}
  isClearable={true}
  styles={{
    container: (base) => ({ ...base, width: '100%' }),
    control: (base) => ({
      ...base,
      width: '100%',
      backgroundColor: inputBg,
      color: inputColor,
      borderColor: 'var(--input-border, #ccc)',
    }),
    input: (base) => ({ ...base, color: inputColor }),
    singleValue: (base) => ({ ...base, color: inputColor }),
    placeholder: (base) => ({ ...base, color: inputColor, opacity: 0.6 }),
    menu: (base) => ({ ...base, backgroundColor: inputBg }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      backgroundColor: isSelected
        ? 'var(--primary-color, #007bff)'
        : isFocused
        ? 'var(--input-hover-bg, rgba(0,0,0,0.1))'
        : inputBg,
      color: inputColor,
    }),
  }}
/>

<Select
  options={timezoneOptions}
  value={selectedTimezone}
  onChange={(option) => setTimezone(option ? option.value : '')}
  placeholder={t('profile.timezone')}
  isSearchable={true}
  isClearable={true}
  styles={{
    container: (base) => ({ ...base, width: '100%' }),
    control: (base) => ({ ...base, width: '100%', backgroundColor: inputBg, color: inputColor }),
    input: (base) => ({ ...base, color: inputColor }),
    singleValue: (base) => ({ ...base, color: inputColor }),
    placeholder: (base) => ({ ...base, color: inputColor, opacity: 0.6 }),
    menu: (base) => ({ ...base, backgroundColor: inputBg }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      backgroundColor: isSelected
        ? 'var(--primary-color, #007bff)'
        : isFocused
        ? 'var(--input-hover-bg, rgba(0,0,0,0.1))'
        : inputBg,
      color: inputColor,
    }),
  }}
/>

        <div className="image-upload">
          <span className="image-upload-label">{t('profile.profileimage')}</span>
          <input 
            type="file" 
            accept="image/*" 
            onChange={(e) => setProfileImage(e.target.files[0] || null)} 
          />
        </div>

<p>{t('profile.social_label')}</p>

<input
  type="url"
  placeholder="Facebook (https://facebook.com/monprofil)"
  value={facebook ?? ''}
  onChange={(e) => setFacebook(e.target.value)}
/>
<input
  type="url"
  placeholder="Instagram (https://instagram.com/monprofil)"
  value={instagram ?? ''}
  onChange={(e) => setInstagram(e.target.value)}
/>
<input
  type="url"
  placeholder="LinkedIn (https://linkedin.com/in/monprofil)"
  value={linkedin ?? ''}
  onChange={(e) => setLinkedin(e.target.value)}
/>
<input
  type="url"
  placeholder={t('profile.website')}
  value={website ?? ''}
  onChange={(e) => setWebsite(e.target.value)}
/>




<textarea
  placeholder={t('profile.bio_placeholder')}
  value={bio ?? ''}
  onChange={(e) => setBio(e.target.value)}
  maxLength={200}
  rows={3}
  style={{ width: '100%', resize: 'vertical' }}
className="textarea"
/>
<span style={{ fontSize: '0.75rem', opacity: 0.6 }}>
  {bio?.length || 0}/200
</span>
 <Alert type="success" message={successMessage} />
<Alert type="error" message={errorMessage} />
        <button onClick={handleUpdateProfile} className="update-button">{t('profile.update')}</button>

              </div>
    </div>
  );
}

export default Profile;